module.exports = {
    TOP_RATED_SELLER: 'top_rated_seller'
};
